import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0c77e063")

_pushScopeId("data-v-0c77e063")
const _hoisted_1 = { class: "custom-tag-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ['custom-tag', _ctx.type],
    style: { maxWidth: _ctx.width + 'px' }
  }, [
    _createVNode("span", _hoisted_1, _toDisplayString(_ctx.text), 1),
    (_ctx.type === 'close')
      ? (_openBlock(), _createBlock("i", {
          key: 0,
          class: "shopyy-iconfont shopyyicon-Close",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }))
      : _createCommentVNode("", true)
  ], 6))
})